import styled from 'styled-components'

const getMargin = props => props.theme.logisterForm.submitButtonMargin || '36px 0 0 0'

const LogisterFormSubmitButtonContainer = styled.div`
  margin: ${getMargin};
`

export default LogisterFormSubmitButtonContainer
